module.exports = __webpack_public_path__ + "img/pause-circle.207fd47e.svg";